import React, { Fragment, useState, useMemo } from "react";
import { Modal, Radio, Checkbox } from "antd";
import Barcode from "react-barcode";

import Button from "components/ui-ant/Button";

import $P from "plugins/tfs/platformConfigs/integrationMaps/packageOrderDetail";
import $ST from "plugins/tfs/platformConfigs/staticTextMaps/packageOrderList";
import { objectSelector, thumbnailImageUrl } from "theme/utils";

// pageContainer
import PrintButton from "_pageContainers/oms/PackageOrderList/printableView";
import "./index.less";


const PrintButtonGrid = (pageContext) => {
  const discountKey = $P.PACKAGE_ITEM.ORDER_ITEM.DISCOUNT_AMOUNT;
  const [groupByMerchant, setGroupByMerchant] = useState(false);

  const {
    selectedFilterAttrs,
    enumValue,
    componentRef,
    loading,
    setLoading,
    modalReady,
    setModalReady,
    data,
    setUncheckedList,
    memoizedGroupedData,
    isPrintable,
    handlePrint,
    handleCheckboxChange,
    loadData,
    statusId,
  } = pageContext;

  const SingleProductView = ({ data, selectedFilterAttrs }) => {
    const [productImage] = data.order_item.product.productimage_set;
    const productInfo = data.order_item.product;
    const orderItem = data.order_item;
    let priceValue = 0;

    return (
      <div key={data.id} className={`printable-list__single-item`}>
        <div className="order-number"></div>

        <div className="product-info">
          {
            <div className="product-name">
              {productInfo.attributes.integration_category3}
            </div>
          }

          {selectedFilterAttrs
            .filter((item) => item.checked)
            .map((f, index) => {
              const orderItemValue = objectSelector(orderItem, f.key, "");
              const productInfoValue = objectSelector(productInfo, f.key, "");

              if (f.key === "price") {
                priceValue = parseFloat(orderItemValue);
              }

              if (f.key === discountKey) {
                if (parseFloat(orderItemValue) > 0.0) {
                  return (
                    <div key={index}>
                      {f.label} :{" "}
                      {(priceValue - parseFloat(orderItemValue)).toFixed(2)}
                    </div>
                  );
                }
                return null;
              }

              return (
                <div key={index}>
                  {f.label} : {productInfoValue || orderItemValue}
                </div>
              );
            })}
        </div>

        {productImage && (
          <div className="printable-product-photo">
            <img
              src={thumbnailImageUrl(productImage.url, 105, 105)}
              height="105"
              alt=""
            />
          </div>
        )}
        <div className="barcode-number">
          <Barcode value={productInfo.attributes.integration_edi} height={55} />
        </div>
      </div>
    );
  };

  const GroupByMerchantView = ({
    data,
    onChange,
    isPrintable,
    isDisabled,
    selectedFilterAttrs,
  }) => {
    return Object.keys(data).map((groupKey) => {
      const printable = isPrintable(groupKey);
      return (
        groupKey && (
          <div
            key={groupKey}
            className={`printable-list__wrapper ${printable ? "" : "noprint"}`}
          >
            <div className="printable-list__group_name">
              <Checkbox
                disabled={isDisabled}
                className="noprint"
                defaultChecked={true}
                checked={printable}
                onChange={(e) => onChange(e, groupKey)}
              />
              {$ST.PRINT_MODAL.GROUP_NAME}: {groupKey}
            </div>
            {data[groupKey].map((subData) => {
              return (
                <SingleProductView
                  key={subData.item.id}
                  data={{ ...subData.item, ...subData }}
                  selectedFilterAttrs={selectedFilterAttrs}
                />
              );
            })}
          </div>
        )
      );
    });
  };

  const GroupByProductView = ({
    data,
    onChange,
    isPrintable,
    isDisabled,
    selectedFilterAttrs,
  }) => {
    return data.map((packageItem) => {
      const { order_number, number, packageitem_set } = packageItem;
      const printable = isPrintable(number);
      if (!packageitem_set.length) return null;
      return (
        <div
          key={number}
          className={`printable-list__wrapper ${printable ? "" : "noprint"}`}
        >
          <div className="printable-list__group_name">
            <Checkbox
              disabled={isDisabled}
              className="noprint"
              defaultChecked={true}
              checked={printable}
              onChange={(e) => onChange(e, number)}
            />
            {$ST.PRINT_MODAL.PACKAGE_NUMBER}: {number}
          </div>
          {packageItem.packageitem_set.map((item) => {
            return (
              <SingleProductView
                key={item.id + number}
                data={{ ...item, order_number, number }}
                selectedFilterAttrs={selectedFilterAttrs}
              />
            );
          })}
        </div>
      );
    });
  };

  const buttonText = useMemo(() => {
    if (loading) return $ST.PRINT_MODAL.PLEASE_WAIT;
    /* check for shipped status */
    if (statusId === 44) return $ST.PRINT_MODAL.PRINT_SHIPPED;
    return $ST.PRINT_MODAL.PRINT;
  }, [loading, statusId]);
  // enum_value = 700 ==> Kargolandı statüsü.
  // eslint-disable-next-line eqeqeq
  const isCheckboxDisabled = enumValue == "700";

  return (
    <Fragment>
      <Modal
        title={$ST.PRINT_MODAL.PRINT_PREVIEW}
        width="75%"
        visible={modalReady}
        onOk={() => {
          handlePrint();
        }}
        okText={$ST.PRINT_MODAL.PRINT}
        cancelText={$ST.PRINT_SETTINGS.CANCEL}
        onCancel={() => {
          setModalReady(false);
          setLoading(false);
          setUncheckedList([]);
        }}
      >
        <Radio.Group
          value={groupByMerchant ? "merchant" : "product"}
          buttonStyle="solid"
          onChange={(e) => {
            const { value } = e.target;
            setGroupByMerchant(value === "merchant");
          }}
        >
          {$ST.PRINT_MODAL.GROUP_BY_MERCHANT && (
            <Radio.Button value="merchant">
              {$ST.PRINT_MODAL.GROUP_BY_MERCHANT}
            </Radio.Button>
          )}
          <Radio.Button value="product">
            {$ST.PRINT_MODAL.GROUP_BY_PRODUCT}
          </Radio.Button>
        </Radio.Group>

        <div ref={componentRef}>
          {groupByMerchant ? (
            <GroupByMerchantView
              data={memoizedGroupedData}
              onChange={handleCheckboxChange}
              isPrintable={isPrintable}
              isDisabled={isCheckboxDisabled}
              selectedFilterAttrs={selectedFilterAttrs}
            />
          ) : (
            <GroupByProductView
              data={data}
              onChange={handleCheckboxChange}
              isPrintable={isPrintable}
              isDisabled={isCheckboxDisabled}
              selectedFilterAttrs={selectedFilterAttrs}
            />
          )}
        </div>
      </Modal>
      <Button
        type="primary"
        loading={loading}
        onClick={loadData}
        disabled={false}
        className="listing-print-button"
      >
        {buttonText}
      </Button>
    </Fragment>
  );
};

export default PrintButton(PrintButtonGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/printableView/index.js